import moment from 'moment';
const appLog: {
  type: 'info' | 'warn';
  time: string;
  message: any[];
}[] = [];

export function info(...args: any) {
  appLog.push({
    type: 'info',
    time: moment().format(),
    message: args,
  });
  if (ENV.BUILD_ENV === 'development') {
    return console.log.apply(null, args);
  }
}
export function warn(...args: any) {
  appLog.push({
    type: 'warn',
    time: moment().format(),
    message: args,
  });
  return console.warn.apply(null, args);
}

// use this to log messages in a development environment,
// these messages won't be included in log dumps e.g. to honeybadger
export function debug(...args: any) {
  if (ENV.BUILD_ENV === 'development') {
    return console.log.apply(null, args);
  }
}
export function dumpAll() {
  return appLog;
}
export function dumpTail(len: number) {
  return appLog.slice(-1 * len);
}
